import { takeEvery, call, put, race, delay } from 'redux-saga/effects'
import { delays } from '../../lib/constants'
import { getLoginFormStrings } from '../../lib/requests/authRequest'

export function* worker({ lang }) {
  try {
    const { result } = yield race({
      result: call(getLoginFormStrings, lang),
      timeout: delay(delays.forCancelRequest),
    })

    if (result && result.status === 200) {
      yield put({ type: 'SET_WORDBOOK', payload: result.data.data })
      yield put({ type: 'SET_LANG', payload: lang })
    } else {
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: 'internal server error',
      })
    }
    yield put({ type: 'CLOSE_ERROR_API' })
    yield put({ type: 'TOGGLE_LANG_SELECT', payload: 0 })
  } catch (e) {
    yield put({ type: 'TOGGLE_LANG_SELECT', payload: 0 })
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
    if (e.response && e.response.data.relogin) {
      yield put({ type: 'SAGA_LOGOUT' })
    }
    if (e.response && e.response.data.forwardTo) {
      yield put({
        type: 'REDIRECT_OUTSIDE',
        payload: e.response.data.forwardTo,
      })
    }
  }
}

export default function* getDumpLang() {
  yield takeEvery('SAGA_CHANGE_LANG', worker)
}
